/* @flow */
import React, { useContext, useRef } from "react";
import Collection from "nexia_mobile/framework/collection";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import NoDevicesPageCommercial from "nexia_mobile/components/Commercial/NoDevicesPageCommercial";
import DeviceDetails from "nexia_mobile/components/Details/DeviceDetails";
import DashboardTilesPage from "nexia_mobile/components/Pages/DashboardTilesPage";
import DeviceSorter from "nexia_mobile/models/device_sorter";
import Session from "nexia_mobile/models/session";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  session?: Session,
  showDeviceAdd: () => void,
};

const BuildingDashboardPage = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.pages.BuildingDashboardPage;
  let tileItemsRef = useRef();

  const loadBuildingTileItems = (locations) => {
    const models = [];
    locations.each((location) => {
      location.allowDeviceListingView();
      return models.push(location);
    });

    const sortedModels = DeviceSorter.sort(models);
    if (tileItemsRef.current) {
      tileItemsRef.current.set(sortedModels);
    } else {
      tileItemsRef.current = new Collection(sortedModels);
    }

    return tileItemsRef.current;
  };

  const loadDeviceTileItems = (location) => {
    const devices = location.get("devices");
    const models = [];
    devices.each((device) => models.push(device));
    const sortedModels = DeviceSorter.sort(models);
    if (tileItemsRef.current) {
      tileItemsRef.current.set(sortedModels);
    } else {
      tileItemsRef.current = new Collection(sortedModels);
    }

    return tileItemsRef.current;
  };

  const { session, showDeviceAdd } = props;
  const locationAppBar = (
    <AppBarWrapper>
      <CommonAppBarContainer title={language.title} />
    </AppBarWrapper>
  );
  const locations = session.get("locations");
  return (
    <BackboneListener listenTo={session} events={["change:locations"]}>
      {() => {
        const firstLocation = locations.first();
        // If location is not present it is covered in Home Page
        // A SpinnerOverlay will be shown
        if (locations.length === 1) {
          const tileItems = loadDeviceTileItems(firstLocation);
          if (tileItems.length === 0) {
            return (
              <NoDevicesPageCommercial
                appBar={locationAppBar}
                showDeviceAdd={showDeviceAdd}
                title={language.noDevicesTitle}
              />
            );
          } else if (tileItems.length === 1) {
            return (
              <DeviceDetails
                model={tileItems.first()}
                appBar={locationAppBar}
                isDashboard
              />
            );
          } else {
            return (
              <DashboardTilesPage
                appBar={locationAppBar}
                location={firstLocation}
                tileItems={tileItems}
              />
            );
          }
        } else {
          const tileItems = loadBuildingTileItems(locations);
          return (
            <DashboardTilesPage
              appBar={locationAppBar}
              location={firstLocation}
              tileItems={tileItems}
            />
          );
        }
      }}
    </BackboneListener>
  );
};

export default BuildingDashboardPage;



// WEBPACK FOOTER //
// ./src/components/Pages/BuildingDashboardPage.jsx